
export class Note {
  id: number;
  parent_id: number | null
  notebook_id: Number;
  userId: string;
  title: string;
  content: string;
  type: string;
  count: number;
  children: Note[];
  // When the note was written, and which campaign it is about (MPN-1640). Declared here
  // because the serializer copies only the keys the constructor defines -- an undeclared
  // field arrives from the API and is silently dropped.
  create_date: string | null;
  launch_id: number | null;
  launch_name: string | null;

  constructor() {
      this.id = -1;
      this.parent_id = null;
      this.notebook_id = 0;
      this.userId = "";
      this.title = "";
      this.content = "";
      this.type = "note";
      this.count = 0;
      this.children = [];
      this.create_date = null;
      this.launch_id = null;
      this.launch_name = null;

  }
}

